import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/wacc-calculator',
  component: () => import('../../routes/WaccCalculator.svelte'),
  card: {
    id: 'wacc-calculator',
    title: 'WACC Calculator',
    description: 'Calculate your company\'s Weighted Average Cost of Capital (WACC). Enter debt, equity, and preferred stock values with their costs to find your overall cost of capital.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/wacc-calculator',
    category: 'Business',
  },
  seo: {
    title: 'WACC Calculator – Weighted Average Cost of Capital',
    description: 'Free WACC calculator to find the blended cost of all capital sources for your business. Enter debt, equity, and preferred stock costs and market values to calculate your overall WACC.',
  },
};

export default meta;
